The secret for signing webhooks.

The secret should be a random string with high entropy that is not reused for any other purpose.
It is used as the key to generate a message authentication code for each request.

This field has a minimum length of 16 characters and a maximum length of 255 bytes in UTF-8 encoding.
